import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SelectActivityRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SelectActivityResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const selectActivity = (request: SelectActivityRequest, options?: CashRequestOptions) =>
  post<SelectActivityRequest, SelectActivityResponse>('/2.0/cash/select-activity', request, {
    ...options,
    rejectOnError: true,
  })
